import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

class FilterCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: null
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.checked !== undefined && nextProps.checked !== prevState.checked) {
      return { checked: nextProps.checked };
    }
    return null;
  }

  handleOnChange = () => {
    const { onChange, name } = this.props;
    const { checked } = this.state;
    this.setState({ checked: !checked });
    onChange(name, !checked);
  };

  render() {
    const { label, name, isColor, checked: propsChecked } = this.props;
    const { checked: stateChecked } = this.state;
    const labelStyle =
      // eslint-disable-next-line no-nested-ternary
      ['departmentName', 'returnStatus', 'creditType', 'catalogs', 'segment'].some(substr => name.includes(substr))
        ? label
        : name.toLowerCase() === 'all'
        ? 'ALL'
        : label.toLowerCase();
    return (
      <div className='ncss-checkbox-container filter-checkbox' onClick={this.handleOnChange}>
        <input
          type='checkbox'
          className='ncss-checkbox'
          name={name}
          checked={stateChecked || propsChecked}
          data-desc={`filters__checkbox_${typeof name === 'string' ? name.toLowerCase() : name}`}
          id='ncss-checkbox-1'
          title={name}
        />
        {!isColor && (
          <>
            <span className='checkbox-box circle' />
            <span className='checkbox-box' />
            <span className='checkbox-box-icon-container'>
              <svg aria-hidden='true' focusable='false' viewBox='0 0 24 24' role='img' height='24px' width='24px'>
                <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                  <g transform='translate(2.000000, 2.000000)'>
                    <rect x='0' y='0' width='20' height='20' rx='10' />
                    <rect x='0' y='0' width='20' height='20' rx='5' className='checkicon-fill' />
                    <path
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7'
                      className='checkicon-check'
                    />
                  </g>
                </g>
              </svg>
            </span>
          </>
        )}
        <label
          className={`ncss-checkbox-label ${labelStyle.toLowerCase() === 'na' ? 'uppercase' : 'u-capitalize'}`}
          htmlFor={name}
        >
          {!isColor && (label && typeof label === 'string' ? <TranslatedCopy id={labelStyle} noWrap /> : labelStyle)}
        </label>
      </div>
    );
  }
}

FilterCheckbox.propTypes = {
  label: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  isColor: PropTypes.bool
};

FilterCheckbox.defaultProps = {
  checked: false,
  isColor: false
};

export default FilterCheckbox;
